// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-number{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}\n", ""]);
// Exports
module.exports = exports;
